

import { ReactComponent as RUNNING } from "../../assets/images/icons/running-status.svg";
import { ReactComponent as STOPPED } from "../../assets/images/icons/stopped-status.svg";
import { ReactComponent as IDLING } from "../../assets/images/icons/idling-status.svg";
import { ReactComponent as OFFLINE } from "../../assets/images/icons/offline-status.svg";
import { ReactComponent as CHARGING } from "../../assets/images/icons/charging-status.svg";
import { ReactComponent as TOWING } from "../../assets/images/icons/towing-status.svg";  

export const VEHICLE_STATUS = [
    {
        name:  "running",
        markerColor: "#388E3C",
        renderIcon: RUNNING
    },
    {
        name:  "stopped",
        markerColor: "#F57C00",
        renderIcon: STOPPED
    },
    {
        name:  "idling",
        markerColor: "#F9A825",
        renderIcon: IDLING
    },
    {
        name:  "offline",
        markerColor: "#757575",
        renderIcon: OFFLINE
    },
    {
        name:  "charging",
        markerColor: "#0288D1",
        renderIcon: CHARGING
    },
    {
        name:  "towing",
        markerColor: "#D32F2F",
        renderIcon: TOWING
    }
];
